import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { ClientePJService } from '../../../service/ClientePJService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ReferenciaBancaria } from '../ReferenciaBancaria';
import { ReferenciaComercial } from '../ReferenciaComercial';
import { AmpliadaCpj } from '../../../models/cpj/AmpliadaCpj';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const InfoApliada = ({ toast, nuevo, back, next, id, permss, catalogos, soloLectura }) => {

    const omodel = new AmpliadaCpj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues });
    const clientepjSrv = new ClientePJService();
    const { inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id])

    const editFicha = () => {
        setIsLoading(true);
        clientepjSrv.consultarClientepj(id, 'p7').then(res => {
            const _clientepj = res.data.clientepj;
            reset(generic.renewValues(_clientepj, omodel.model));
        }).finally(() => {
            setIsLoading(false)
        });
    }

    const onSubmit = (data) => {
        if (catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA') {
            next();
            return;
        }
        setIsSaving(true);
        data.paso = 'p7';
        data.id = id;
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        clientepjSrv.editarClientepj(data).then(res => {
            generic.funcSuccess(res, toast);
            next(id);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form id="infoApliadaForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header="PARTE C" className="panel-ficha mb-4">

                    {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && (
                        <Panel header={generic.renderPanelHeader('C.1', 'INFORMACIÓN ECONÓMICA DEL REPRESENTANTE LEGAL / APODERADO', 'pi pi-wallet')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid">

                                {/* Bloque Representante Legal */}
                                <div className="col-12 md:col-6 mb-3">
                                    <div className="text-800 font-bold mb-3 border-bottom-1 border-300 pb-2 flex align-items-center gap-2">
                                        <i className="pi pi-user text-primary"></i>
                                        Información Económica del Representante Legal
                                    </div>
                                    <div className="formgrid grid">
                                        {inNumber('INGR_MENSUAL_RL', 2, true, { icon: 'pi pi-dollar' }, 6)}
                                        {inNumber('EGRE_MENSUAL_RL', 2, true, { icon: 'pi pi-dollar' }, 6)}
                                    </div>
                                </div>

                                {/* Bloque Apoderado */}
                                <div className="col-12 md:col-6 mb-3">
                                    <div className="text-800 font-bold mb-3 border-bottom-1 border-300 pb-2 flex align-items-center gap-2">
                                        <i className="pi pi-id-card text-primary"></i>
                                        Información Económica del Apoderado
                                    </div>
                                    <div className="formgrid grid">
                                        {inNumber('INGR_MENSUAL_AP', 2, true, { icon: 'pi pi-dollar' }, 6)}
                                        {inNumber('EGRE_MENSUAL_AP', 2, true, { icon: 'pi pi-dollar' }, 6)}
                                    </div>
                                </div>

                            </div>
                        </Panel>
                    )}

                    <Panel header={generic.renderPanelHeader('C.2', 'REFERENCIAS DE LA COMPAÑÍA', 'pi pi-address-book')} className="panel-ficha shadow-1 mb-4">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-building-columns text-primary"></i>
                                    REFERENCIAS BANCARIAS
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>
                        <ReferenciaBancaria tipo="pj" id={id} toast={toast} permss={permss} bvg={false} num={8} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} soloLectura={soloLectura} />

                        <div className="col-12 mt-5 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-briefcase text-primary"></i>
                                    REFERENCIAS COMERCIALES
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>
                        <ReferenciaComercial tipo="pj" id={id} toast={toast} permss={permss} num={9} soloLectura={soloLectura} />
                    </Panel>
                </Panel>

                <BottomActionBar formId="infoApliadaForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </>
    );
}
